/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  // Funduino-Aenderung (Phase B, 01.10.2026): 8 statt 4. "Kategorie · Zuletzt"
  // (sections/fu-kategorie-zuletzt.liquid) zeigt am Computer eine Reihe mit so
  // vielen Karten, wie die Produktliste darueber nebeneinander zeigt — bis 6,
  // in der kompakten Ansicht bis 8 — und am Handy alle gespeicherten in der
  // Wischleiste (Timo, 01.10.2026). Horizons Suchfenster bleibt bei 4: Es
  // fragt nur die ersten 4 ab (assets/predictive-search.js,
  // #getRecentlyViewedProductsMarkup). Weitere Leser des Verlaufs gibt es nicht
  // (grep nach RecentlyViewed und viewedProducts, 01.10.2026). Eingetragen in
  // Dokumentation/Bausteine/Horizon-Aenderungen.md.
  static #MAX_PRODUCTS = 8;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
